module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/BC4062-16fc0bd5a30b28efa93e83b96ed11840.png";